import { Outlet } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { WhatsAppButton } from "./WhatsAppButton";
import { BackToTop } from "@/components/BackToTop";
import { AccessibilityWidget } from "@/components/AccessibilityWidget";
import { CookieConsent } from "@/components/CookieConsent";

export const Layout = () => (
  <div className="min-h-screen flex flex-col">
    <Header />
    <main className="flex-1 pb-24 sm:pb-0">
      <Outlet />
    </main>
    <Footer />
    <WhatsAppButton />
    <BackToTop />
    <AccessibilityWidget />
    <CookieConsent />
  </div>
);
